module.exports = __webpack_public_path__ + "img/Rooms_text01b_tableCD.2208322e.png";